React = require 'react'
SchedulingMixin = require 'lib/scheduling-mixin'
mixin = require 'lib/mixin'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_search')

module.exports = class extends React.Component
  constructor: (props) ->
    super(props)

    @scheduler = new SchedulingMixin()

    @state = {
      searchHasFocus: false
      query: ""
    }

  componentWillReceiveProps: (nextProps) ->
    if nextProps.clearValue
      @refs['search-input'].value = ""
      @setState query: ""

  componentWillMount: ->
    @debouncedOnQueryChange = @scheduler.debounce(@onQueryChange, 300)

  componentWillUnmount: ->
    # cancels the debounced change listener
    @scheduler.cancelScheduled()

  render: t.renderable ->
    t.div '.enterprise-search-wrapper', =>
      t.input '.enterprise-search-input',
        class: t.classify('js-autofocus': @props.autofocus != false)
        type: 'text'
        ref: 'search-input'
        placeholder: @props.placeholder
        onFocus: (e) => @setState searchHasFocus: true
        onBlur: (e) => @setState searchHasFocus: false
        onChange: (e) =>
          query = e.target.value.trim()
          @setState { query }
          if @props.debounce
            @debouncedOnQueryChange(query)
          else
            @onQueryChange(query)

      if @state.query != ""
        t.span '.enterprise-search-close-icon.icon-lg.icon-close.light',
          class: t.classify('active': @state.searchHasFocus)
          onClick: @onClearClick

  onQueryChange: (query) => @props.onChange(query)

  onClearClick: =>
    @refs['search-input'].value = ""
    @setState query: ""
    @props.onChange("")



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/search-component.coffee